import { useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import ReactDOM from "react-dom";

export const useReplaceDropdowns = (
  changeCPlace,
  changeUniversalAssetPicker,
  changeForm,
  onOptionClick,
  bubbles,
) => {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const card =
        bubbles[bubbles.length - 1]?.querySelector(".ac-adaptiveCard");
      if (!card) return;
      card.querySelectorAll("select").forEach((select) => {
        if (select.dataset.replaced) return;
        /*if (changeCPlace || changeUniversalAssetPicker || changeForm) {
          select.dataset.replaced = "true";
          return;
        }*/

        const options = Array.from(select.options).map((o) => o.text);
        const values = Array.from(select.options).map((o) => o.value);
        const isMulti = select.hasAttribute("multiple");
        if (isMulti) return;
        // Hide the original select (to keep validation intact)
        select.style.position = "absolute";
        select.style.opacity = "0";
        select.style.width = "0";
        select.style.height = "0";
        select.style.pointerEvents = "none";

        // Create a container for MUI Autocomplete
        const container = document.createElement("div");
        container.classList.add("mui-autocomplete-container");
        select.parentNode?.insertBefore(container, select.nextSibling);

        const handleChange = (_event, value, reason) => {
          // Update hidden select's value

          const selectedValue = Array.isArray(value) ? value[0] : value;

          // Find the option by text OR value
          const matchingOption = Array.from(select.options).find(
            (opt) =>
              opt.text.trim() === selectedValue?.trim() ||
              opt.value.trim() === selectedValue?.trim(),
          );

          // Explicitly clear old selections
          Array.from(select.options).forEach((opt) => (opt.selected = false));

          if (matchingOption) {
            matchingOption.selected = true;
            select.value = matchingOption.value;
          } else {
            console.warn("⚠️ No matching option found for:", selectedValue);
            select.value = "";
          }

          // Dispatch 'change' event so validation hooks notice the change
          select.dispatchEvent(new Event("input", { bubbles: true }));
          select.dispatchEvent(new Event("change", { bubbles: true }));

          // Notify validation logic (your other hook)
          const input = container.querySelector("input");
          if (input) {
            input.dataset.hasValue = !!selectedValue;
            input.dispatchEvent(
              new CustomEvent("autocompleteChange", {
                bubbles: true,
                composed: true,
              }),
            );
          }

          if (reason === "selectOption" && onOptionClick) {
            onOptionClick(value);
          }
          // Optional: post activity to bot
          // directLine.postActivity({...}).subscribe();
        };

        // Render MUI Autocomplete into the container
        ReactDOM.render(
          <Autocomplete
            options={options.slice(1)}
            label={null}
            InputLabelProps={{ shrink: false }}
            defaultValue={""}
            renderInput={(params) => (
              <TextField {...params} sx={{ width: "100%" }} />
            )}
            onChange={handleChange}
          />,
          container,
        );

        select.dataset.replaced = "true";
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [
    changeCPlace,
    changeUniversalAssetPicker,
    changeForm,
    onOptionClick,
    bubbles,
  ]);
};
